/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type BackgroundImagePickerContainer_app$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundSettingsContainer_app$ref: FragmentReference;
export type BackgroundSettingsContainer_app = {|
  +$fragmentRefs: BackgroundImagePickerContainer_app$ref,
  +$refType: BackgroundSettingsContainer_app$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundSettingsContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BackgroundImagePickerContainer_app",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '940de37edc00e37d1865d1b34d1ff688';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Background/__generated__/BackgroundSettingsContainer_app.graphql.js